import { registerPlugin } from '@capacitor/core';
import type { StorageMigrationPlugin } from './definitions';
import { StorageMigrationWeb } from './web';

// Enregistrer le plugin avec registerPlugin
const StorageMigration = registerPlugin<StorageMigrationPlugin>('StorageMigration', {
  web: () => new StorageMigrationWeb(),
});

export * from './definitions';
export { StorageMigration };
